import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from '@angular/core';

import {
  YourData,
  YourDataContext,
  getSVGViewBox
} from '../assets';

@Component({
  selector: 'kyc-icon-your-data',
  template: YourData.svg,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class YourDataComponent implements SVG2TSDynamic, OnInit {
  public static UUID = 0;
  public baseUrl: string;
  @Input() public height: number | string = YourData.height;
  @Input() public viewBox: string = getSVGViewBox(YourData.viewBox);
  @Input() public width: number | string = YourData.width;
  @Input()
  public set context(ctx: YourDataContext) {
    this.updateContext(ctx);
  }
  public get context() {
    return this._context;
  }

  private _context: YourDataContext = YourData.contextDefaults;

  constructor(private _ref: ChangeDetectorRef) {}


  public getURLBase(value: string) {
    return `url('${this.getXlinkBase(value)}')`;
  }

  public getXlinkBase(value: string) {
    return `${this.baseUrl}${value}`;
  }

  public ngOnInit() {
    this.baseUrl = window.location.href.replace(window.location.hash, '');
    this.context.uuid = YourDataComponent.UUID++;
  }

  public updateContext(ctx: any) {
    this._context = Object.assign({}, this._context ? this._context : YourData.contextDefaults, ctx);
    this._ref.markForCheck();
  }
}
